<script setup lang="ts">
import { ref } from "vue";

const props = defineProps<{
  modalId: string;
  buttonLabel: string;
  header?: boolean;
  wide?: boolean;
  noOkay?: boolean;
  sharp?: boolean;
  noCancel?: boolean;
  cancelButtonLabel?: string;
  modalStyle?: string;
}>();

const emit = defineEmits<{
  (event: "modal-cancel"): void;
  (event: "modal-okay"): void;
}>();

const show = ref(props.buttonLabel === "");

const open = (): void => {
  show.value = !show.value;
};

const close = (): void => {
  show.value = false;
};

const cancel = (): void => {
  close();
  emit("modal-cancel");
};

const okay = (): void => {
  close();
  emit("modal-okay");
};
</script>

<template>
  <button
    v-if="buttonLabel"
    class="btn btn-sm btn-outline-secondary custom-button"
    :class="{ wide: wide, sharp: sharp }"
    @click.stop.prevent="open"
  >
    <b>{{ buttonLabel }}</b>
  </button>

  <div v-if="show" :id="modalId" class="modalz-mask" @click.stop.prevent="cancel">
    <div class="modalz" :style="modalStyle" @click.stop="">
      <div v-if="header" class="modalz-header">
        <slot name="header"></slot>
      </div>
      <div class="modalz-body">
        <slot></slot>
      </div>
      <div class="modalz-footer">
        <button v-if="!noCancel" class="btn btn-sm btn-light" @click.stop.prevent="cancel">
          {{ cancelButtonLabel ?? "Cancel" }}
        </button>
        <slot name="footer"></slot>
        <button v-if="!noOkay" class="btn btn-sm btn-primary" @click.stop.prevent="okay">Okay</button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.modalz {
  background-color: white;
  color: black;
  margin: auto;
  border: 1px solid blue;
  border-radius: 0.5rem;
  max-width: 70%;
  margin-top: 10%;

  &,
  &-mask {
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }

  &-mask {
    position: absolute;
    z-index: 9998;
    background: rgba(0, 0, 0, 0.2);
  }
}
.modalz-header {
  background-color: whitesmoke;
  color: black;
  padding: 1rem;
  border-radius: 0.5rem 0.5rem 0 0;
  border-bottom: 1px solid lightgray;
}

.modalz-body {
  background-color: white;
  color: black;
  padding: 20px;
  margin: 1rem;
}
.modalz-footer {
  background-color: #e9ecef;
  color: black;
  padding: 1rem;
  border-radius: 0 0 0.5rem 0.5rem;
  border-top: 1px solid lightgray;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.wide {
  width: 100%;
}
.custom-button {
  height: 2.2rem;
  background-color: white;
  --bs-btn-hover-color: #000;
  --bs-btn-border-color: #ced4da;
  min-width: min-content;
}
.sharp {
  border-radius: 0;
}
</style>
